import Api from "app/services/common/Api";
import { EnrgMonthAggData, EnrgMonthTrendData } from "app/model/mg/pwrModel";
import {RoadmapType} from "app/model/cp/Roadmap";
import {ApiUrlUtil} from "app/utils/apiUrlUtil";

export class DbService extends Api {
  private static service: DbService;

  public static getInstance(): DbService {
    if (!DbService.service) {
      DbService.service = new DbService();
    }
    return DbService.service;
  }

  // Admin Dashboard : 이번 달 에너지 현황 - Chart
  public async getEnrgMonthTrend(fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/db/energy/month/trend';
    const param = { fromDt: fromDt };
    return await super.get<EnrgMonthTrendData[]>(url, param);
  }

  // Admin Dashboard : 이번 달 에너지 현황 - 합산
  public async getEnrgMonthAgg(fromDt: string) {
    const url: string = process.env.REACT_APP_URL_CO + '/db/energy/month/agg';
    const param = { fromDt: fromDt };
    return await super.get<EnrgMonthAggData>(url, param);
  }

  // Admin Dashboard : 이번달 월 탄소배출량 - 합산
  public async getEnrgMonthCarbon() {
    const url: string = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/dashboard/month"
    );
    return await super.get<RoadmapType>(url);
  }

  // Admin Dashboard : 이번달 월 탄소배출량 - 합산
  public async getEnrgYearCarbon() {
    const url: string = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP + "/EmissionsStatus/admin/dashboard/year"
    );
    return await super.get<RoadmapType>(url);
  }

  // Admin Dashboard : 금년 RE100 달성률 && 산단 RE100 현황
  public async getStatistics() {
    const url: string = process.env.REACT_APP_URL_CO + '/company/statistics';
    return await super.get<any>(url);
  }

  public async getUserCount() {
    const url: string = process.env.REACT_APP_URL_CO + '/company/count';
    return await super.get<any>(url);
  }
}